import dynamic from 'next/dynamic';

import clsx from 'clsx';

// Types
import type { mutateNotificationsType } from '@/utils/hooks/swr/useNotifications';
import useTranslation from '@/utils/hooks/translation/useTranslation';

import useToggle from '@/utils/hooks/utils/useToggle';

// Components
import Icon from '@/components/base/Icon';
const DeleteAllReadNotificationsModal = dynamic(
    () => import('@/components/pages/notifications/modals/DeleteAllReadNotificationsModal')
);

const ButtonDeleteNotificationsRead = ({
    mutateNotifications
}: {
    mutateNotifications: mutateNotificationsType;
}) => {
    const { isOpen, toggle } = useToggle();
    const { t } = useTranslation();
    return (
        <>
            <button
                className={clsx(
                    'flex items-center space-x-2 text-xs text-icoRed',
                    'h-10 w-10 justify-center rounded-full bg-white dark:bg-icoDarkMode-deepBlack',
                    'lg:h-auto lg:w-auto lg:rounded-none lg:bg-transparent lg:dark:bg-transparent'
                )}
                onClick={toggle}>
                <Icon icon="trash" className="text-sm" />
                <span className="hidden lg:inline-block">{t('notifications:delete_all_read')}</span>
            </button>
            <DeleteAllReadNotificationsModal
                isOpen={isOpen}
                toggle={toggle}
                mutateNotifications={mutateNotifications}
            />
        </>
    );
};

export default ButtonDeleteNotificationsRead;
